
export function capitalize(name: string): string {
    const words = name.split(' ');
    const processedWords = words.map(word => {
        const firstLetter = word.charAt(0).toUpperCase();
        const restOfWord = word.slice(1).toLowerCase();
        return firstLetter + restOfWord;
    });
    return processedWords.join(' ');           
}

declare global {
    interface String {
        capitalize(): string
    }
}

String.prototype.capitalize = function() {
    return capitalize(this.toString())
}

class Utils {
    // Function to check if current time is between two times
    static isCurrentTimeBetween(startTime, endTime) {
        const currentTime = new Date();
    
        // Creating a start time for today
        const startTimeDate = new Date(currentTime);
        startTimeDate.setHours(startTime.split(":")[0], startTime.split(":")[1], 0); // Set hours and minutes
    
        // Creating an end time for today
        const endTimeDate = new Date(currentTime);
        endTimeDate.setHours(endTime.split(":")[0], endTime.split(":")[1], 0); // Set hours and minutes
    
        // Check if current time is after start time and before end time
        return currentTime >= startTimeDate && currentTime <= endTimeDate;
    }

    static getDayStringFromTimestamp(timestamp, timezone = "America/Argentina/Buenos_Aires") {
        let date = new Date(timestamp)
        let options = { timeZone: timezone }; // set the timezone to GMT-3
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            throw new Error('Invalid timestamp provided.')
        }
        let stringDate = date.toLocaleString('es-AR', options)
        let array = stringDate.substring(0,10).split("/")
        while (array[1].length < 2) {
            array[1] = "0" + array[1];
        }
        while (array[0].length < 2) {
            array[0] = "0" + array[0];
        }
        let day = array[2].replace(",", "").replace(" ", "") + "-" + array[1] + "-" + array[0] 
        return day
    }

}


export default Utils;